import React, { useCallback, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useAuthContext } from '../contexts/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import HAppRoutes from '../../../app/features/routes/helpers/HAppRoutes';
import AdminRoutes from '../../admin/AdminRoutes';
import InvestorRoutes from '../../investor/InvestorRoutes';
import _ from 'lodash';
import AppLoaderPage from '../../../app/features/loader/page/AppLoaderPage';
import langAuthLogin from '../features/login/langs/langAuthLogin';
import { useTranslation } from 'react-i18next';
import useAuthOktaUser from '../../../app/hooks/useAuthOktaUser';
import AuthRoutes from '../AuthRoutes';
import { globalConfig } from '../../../app/config/config';

const PAuthLoginCallback = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { setAuthContext, authContext, setAuthAccessToken, setAuthUserProfile, redirectUri, resetRedirectUri } =
		useAuthContext();

	const routeParams = useParams();

	const { oktaAuth, authState } = useOktaAuth();
	const oktaAuthUser = useAuthOktaUser();

	const redirectAfterLogin = useCallback(
		(context: 'employee' | 'investor') => {
			setAuthContext(context);
			if (context === 'employee') {
				navigate(HAppRoutes.getPath(AdminRoutes.dashboard.tag));
			} else {
				if (redirectUri) {
					const redirectUriTmp = _.clone(redirectUri);
					resetRedirectUri();
					navigate(redirectUriTmp);
				} else {
					navigate(HAppRoutes.getPath(InvestorRoutes.dashboard.tag));
				}
			}
			return null;
		},
		[navigate, redirectUri, resetRedirectUri, setAuthContext],
	);

	useEffect(() => {
		if (authState) {
			if (authState.isAuthenticated) {
				if (globalConfig.get().APP_OKTA_CLIENT_ID_AUTH === authState.idToken?.clientId) {
					// Employee
					setAuthContext('employee');
					setAuthAccessToken(oktaAuth.getAccessToken() ?? '');
					oktaAuth.getUser().then((info) => {
						setAuthUserProfile(info);
						redirectAfterLogin('employee');
					});
				} else if (globalConfig.get().APP_OKTA_USER_CLIENT_ID_AUTH === authState.idToken?.clientId) {
					setAuthContext('investor');
					setAuthAccessToken(oktaAuthUser.getAccessToken() ?? '');
					oktaAuthUser.getUser().then((info) => {
						setAuthUserProfile(info);
						redirectAfterLogin('investor');
					});
				}
			} else {
				navigate(HAppRoutes.getPath(AuthRoutes.logout.tag));
			}
		}
	}, [
		routeParams,
		authContext,
		authState,
		oktaAuth,
		oktaAuthUser,
		setAuthContext,
		setAuthAccessToken,
		setAuthUserProfile,
		redirectAfterLogin,
		navigate,
	]); // Update if authState changes

	return <AppLoaderPage title={t(langAuthLogin.loader_authentification.tag)} />;
};

export default PAuthLoginCallback;
